import type {BrandKitWithAssets} from '@Components/mystuff-brands/brand-kits.types';
import {useActiveBrandId} from '@Hooks/brands/useActiveBrandId';
import {useBrandKitsWithAssets} from '@Hooks/brands/useBrandKitsWithAssets';
import {doesBrandHaveAllAssetTypes} from '@Libraries/brands-library';

/**
 * the active brand kit is fixed at the start, and the others are sorted by 'completeness'.
 * whichever has more assets, is given priority
 */
export const useSortedBrandKitsWithAssets = (selectedBusinessProfileBrandId?: string | null): BrandKitWithAssets[] => {
  const activeBrandId = useActiveBrandId();
  const brandKitsWithAssets: BrandKitWithAssets[] = useBrandKitsWithAssets();
  return getSortedBrandKitsWithAssets(brandKitsWithAssets, activeBrandId, selectedBusinessProfileBrandId);
};

export const getSortedBrandKitsWithAssets = (
  brandKitsWithAssets: BrandKitWithAssets[],
  activeBrandId?: string | null,
  selectedBusinessProfileBrandId?: string | null
): BrandKitWithAssets[] => {
  let sortedBrandKitsWithActiveBrand: BrandKitWithAssets[] = [];
  const selectedBrand = [];
  const activeBrand = [];
  const brandKitsToSort = [];

  for (const brandKitWithAsset of brandKitsWithAssets) {
    if (brandKitWithAsset.brandKit.brandId === selectedBusinessProfileBrandId) {
      selectedBrand.push(brandKitWithAsset);
    } else if (brandKitWithAsset.brandKit.brandId === activeBrandId) {
      activeBrand.push(brandKitWithAsset);
    } else {
      brandKitsToSort.push(brandKitWithAsset);
    }
  }

  const sortedBrandKits = brandKitsToSort.sort((brandKit1, brandKit2) => {
    const brandKit1HasAllAssets = doesBrandHaveAllAssetTypes(brandKit1.brandKit.brandId);
    const brandKit2HasAllAssets = doesBrandHaveAllAssetTypes(brandKit2.brandKit.brandId);

    if (brandKit1HasAllAssets && !brandKit2HasAllAssets) {
      return -1;
    }
    if (!brandKit1HasAllAssets && brandKit2HasAllAssets) {
      return 1;
    }

    return 0;
  });

  sortedBrandKitsWithActiveBrand = [...selectedBrand, ...activeBrand, ...sortedBrandKits];

  return sortedBrandKitsWithActiveBrand;
};
